<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="appStore.sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar"/>
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!settingsStore.topNav"/>
    <top-nav id="topmenu-container" class="topmenu-container" v-if="settingsStore.topNav"/>

    <div class="right-menu">
      <template v-if="appStore.device !== 'mobile'">
        <!--        <header-search id="header-search" class="right-menu-item" />-->

        <!--        <el-tooltip content="源码地址" effect="dark" placement="bottom">-->
        <!--          <ruo-yi-git id="ruoyi-git" class="right-menu-item hover-effect" />-->
        <!--        </el-tooltip>-->

        <!--        <el-tooltip content="文档地址" effect="dark" placement="bottom">-->
        <!--          <ruo-yi-doc id="ruoyi-doc" class="right-menu-item hover-effect" />-->
        <!--        </el-tooltip>-->
        <Notification class="right-menu-item hover-effect"/>

        <screenfull id="screenfull" class="right-menu-item hover-effect"/>

        <NotificationSoundSwitch class="right-menu-item hover-effect"/>

        <!--        <el-tooltip content="布局大小" effect="dark" placement="bottom">-->
        <!--          <size-select id="size-select" class="right-menu-item hover-effect" />-->
        <!--        </el-tooltip>-->

        <el-tooltip v-if="daPingFlag" v-isInnerAdmin content="转至大屏页面" effect="dark" placement="bottom">
          <switch-big-screen id="switch-big-screen" class="right-menu-item hover-effect"></switch-big-screen>
        </el-tooltip>

      </template>
      <div class="avatar-container">
        <el-dropdown @command="handleCommand" class="right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <img :src="userStore.avatar" class="user-avatar"/>
            <el-icon color="#CFD3DC">
              <caret-bottom/>
            </el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>

              <!--              <el-dropdown-item command="setLayout">-->
              <!--                <span>布局设置</span>-->
              <!--              </el-dropdown-item>   -->

              <router-link to="/user/message">
                <el-dropdown-item>
                  <div style="position: relative">
                    <div v-if="userStore.unreadMsgAmount > 0" class="point"></div>
                    我的消息
                  </div>
                  </el-dropdown-item>
              </router-link>

              <el-dropdown-item divided command="logout">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ElMessageBox} from 'element-plus'
import Breadcrumb from '@/components/Breadcrumb'
import TopNav from '@/components/TopNav'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import HeaderSearch from '@/components/HeaderSearch'
import RuoYiGit from '@/components/RuoYi/Git'
import RuoYiDoc from '@/components/RuoYi/Doc'
import useAppStore from '@/store/modules/app'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'
import SwitchBigScreen from '@/components/SwitchBigScreen'
import Notification from "@/components/Notification/Notification";
import NotificationSoundSwitch from "@/components/Notification/NotificationSoundSwitch";

const daPingFlag = !((localStorage.getItem('tenantId') == 54) || (JSON.parse(sessionStorage.getItem('sessionObj')) &&  JSON.parse(sessionStorage.getItem('sessionObj')).data  && ((JSON.parse(JSON.parse(sessionStorage.getItem('sessionObj')).data).tenantId == 54))));
const appStore = useAppStore()
const userStore = useUserStore()
const settingsStore = useSettingsStore()

function toggleSideBar() {
  appStore.toggleSideBar()
}

function handleCommand(command) {
  switch (command) {
    case "setLayout":
      setLayout();
      break;
    case "logout":
      logout();
      break;
    default:
      break;
  }
}

function logout() {
    try {
        localStorage.removeItem('tenantId')
    }catch (e) {

    }

  ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    userStore.logOut().then(() => {
      location.href = '/index';
    })
  }).catch(() => {
  });
}

const emits = defineEmits(['setLayout'])

function setLayout() {
  emits('setLayout');
}
</script>

<style lang='scss' scoped>
@import "@/assets/styles/variables.module.scss";

.navbar {
  height: 100px;
  overflow: hidden;
  position: relative;
  background-color: $nav-menu-background;
  //background: #fff;
  box-shadow: 0 3px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 100px;
    height: 100px;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(58, 125, 150, 0.69);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    background-color: $nav-menu-background;
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      line-height: 100px;
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 40px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.point {
  position: absolute;
  top: 0;
  right: -5px;
  width: 6px;
  height: 6px;
  background: red;
  border-radius: 50%;
}
</style>
